var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar"},[_c('div',{staticClass:"navbar-container"},[_c('div',{staticClass:"logo-container"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo/kurpot-logo-d.svg"),"alt":"Shower Santonic Logo"}})])])])
}]

export { render, staticRenderFns }